import { Component, OnInit } from '@angular/core';
import { AppService } from "../../app.service";

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent implements OnInit {
  isAdmin: boolean;
  constructor(private appService: AppService) { }

  ngOnInit() {
    this.isAdmin = this.appService.getCurrentUser().role == 'ADMIN';
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout/side-bar/side-bar.component.ts